var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreVertIcon = function SvgMoreVertIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.313 6c.345 0 .625-.448.625-1s-.28-1-.625-1c-.346 0-.625.448-.625 1s.28 1 .625 1M5.313 10c.345 0 .625-.448.625-1s-.28-1-.625-1c-.346 0-.625.448-.625 1s.28 1 .625 1M5.313 14c.345 0 .625-.448.625-1s-.28-1-.625-1c-.346 0-.625.448-.625 1s.28 1 .625 1"
  })));
};
export default SvgMoreVertIcon;